import React from 'react';
import Types from '../../constants/Types';
import ObjectOverride from '../ObjectOverride';
import ModuleCard from './ModuleCard';

class LocationsList extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
	}

	render() {
		// Destructuring for cleaner code
		const {
			object, history, rootState, handleAfterSave,
			subscriptionUsage, subscriptionUsageLoading, subscriptionUsageError, reloadSubscriptionUsage
		} = this.props;
		const { subscriptions, selectedActualLocation, locations, location, location_binary_id } = object;
		const { locationSelected, locationSelectedBinaryId } = rootState;
		const firstActiveLocation = rootState.locations.find(loc => !loc.archived);
		const isEnterpriseSubscription = selectedActualLocation[0].subscriptions?.id === ['ffl_enterprise', 'ffl_enterprise_1', 'ffl_enterprise_2', 'ffl_enterprise_4', 'ffl_enterprise_05', 'ffl_enterprise_5', 'ffl_enterprise_6'];
		const hasEnterprise = selectedActualLocation[0].subscriptions?.id?.includes('ent');

		const filteredSubscriptions = hasEnterprise
			? subscriptions.items
			: subscriptions?.items?.filter(sub => !sub.id.includes('ent'));

		return (
			<>
				<hr></hr>
				<h4 style={{ fontWeight: 'bold' }}>Locations Subscriptions</h4>
				<div className={'row'} id={'moduleCardsContainer'}>
					{/*Account Subscription Modules*/}

					{filteredSubscriptions && filteredSubscriptions.map((data, key) => {
						let found = false;
						if (selectedActualLocation[0].subscriptions?.pkey === data.pkey) {
							found = true;
						}
						return (
							<ModuleCard
								moduleClass={""}
								price={data.price}
								moduleId={data.id}
								borderStyle={found ? '#1bbc9b' : '#dbdbdb'}
								type={data.description}
								ffl={locations.ffl}
								name={selectedActualLocation[0]?.name_display || selectedActualLocation[0]?.name}
								history={history}
								isSubscribed={found}
								locationBinaryId={locationSelected ? locationSelectedBinaryId : (location ? location_binary_id : firstActiveLocation.binary_id)}
								location={locationSelected ? locationSelected : (location ? location : firstActiveLocation.pkey)}
								locationSelected={selectedActualLocation[0]}
								isDisabled={isEnterpriseSubscription}
								handleAfterSave={handleAfterSave}
								subscriptionUsage={subscriptionUsage}
								subscriptionUsageLoading={subscriptionUsageLoading}
								subscriptionUsageError={subscriptionUsageError}
								reloadSubscriptionUsage={reloadSubscriptionUsage}
								key={key}
							/>
						);
					})}
				</div>
			</>
		);
	}
}

export default LocationsList;
